import ResponsiveImage from '~/components/Image/ResponsiveImage'

export const MuteElement = (): React.ReactElement => {
  return (
    <ResponsiveImage
      alt="Mute Button"
      height={120}
      imageClassName="w-9 lg:w-12"
      imageWidths="115"
      loading="eager"
      srcKey="Math Vault/icons/mute_button1.png"
      width={115}
    />
  )
}

export const UnMuteElement = (): React.ReactElement => {
  return (
    <ResponsiveImage
      alt="Unmute Button"
      height={120}
      imageClassName="w-9 lg:w-12"
      imageWidths="115"
      loading="eager"
      srcKey="Math Vault/icons/unmute_button3.png"
      width={115}
    />
  )
}
